export default {"src":"/_next/static/media/icone-helio.71eb1e8b.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};